import { Option } from 'api/api_code';

const transformOptions = (options: Option[]) => {
	return options.map((option) => ({
		label: option.display_name,
		value: option.value as string | number,
	}));
};
export default transformOptions;
